var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-ht",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M0 0h512v256H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.183
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M175.24 191.63h161.52v128.583H175.24z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.507 284.614l-32.963.957-32.814.374s-16.86 6.235-23.75 7.634c-6.872 1.396-5.978 3.653-11.295 4.84-4.26.953-4.75 1.253-7.25 1.417-1.512.1-3.374 1.263-5.196 2.545v17.833h161.52V303.25c-1.75-.953-3.418-1.61-5.126-2.19-2.373-.807-3.972-1.69-8.23-2.64-5.318-1.19-4.425-3.446-11.296-4.842-6.892-1.4-23.6-8.964-23.6-8.964z",
    fill: "#016a16",
    stroke: "#016a16",
    strokeWidth: 0.312
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-170.667) scale(1.70667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.53 143.512l1.396-.033 2.555 10.748-.544 3.386-3.407-14.102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.064 136.346l.954 8.284 1.022-.066-1.976-8.218z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.722 154.59l-4.293-11.54 1.6-.098 5.01 14.102-2.318-2.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.42 136.477l1.77 8.02h1.432l-3.203-8.02z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.906 150.546l-2.52-5.424 1.09-.23 4.6 9.007-3.17-3.354z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.08 138.778l2.794 7.626h1.43l-4.224-7.626z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25 151.364l-11.437-12.484c-3.57 2.828-2.908 8.02-2.908 8.02l12.957 10.167 1.387-5.703z",
    fill: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.86 158.235l-8.482-8.594c-3.587.126-.74 5.48-.56 6.153l9.043 7.734v-5.292z",
    fill: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.14 156.757l-17.54-18.78-.685.483 18.56 20.622-.336-2.325zm-18.554-19.985l-.385-.446.04-.89-3.62-2.304 1.617 3.64 1.232.223.384.446.732-.668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.738 138.11c.616-.743 1.348-1.486 2.657-2.192l1 1.45-2.155 1.82-1.502-1.078z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.81 141.278l.59 1.026c.363-.135 4.03-3.457 4.03-3.457l2.632-.08.756-.838c-1.932-2.08-3.752.296-3.752.296l-4.255 3.052z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.91 143.007c.14-.918 1.877-3.214 2.13-3.295 1.302.39 2.514 1.14 3.834-1.837-1.148 1.46-3.47-.027-3.47-.027l-1.01.838.03.405-3.053 2.837 1.54 1.08z",
    fill: "#d20014",
    stroke: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.252 154.672l-14.367-11.41c-2.46 2.502-.415 10.23-.415 10.23l14.043 7.608.74-6.428z",
    fill: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.166 163.917l-11.818-9.467c-4.036.566-.864 6.506-.623 7.16l12.48 6.77-.04-4.463z",
    fill: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.697 162.005l-25.554-19.182-.587.59 26.837 20.956-.696-2.365zm-26.769-20.198l-.46-.374-.122-.885-3.98-1.662 2.25 3.314 1.253.014.458.374.6-.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.35 143.433c.472-.835 1.06-1.69 2.22-2.603l1.247 1.26-1.795 2.152-1.673-.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.925 146.64l.16 1.06c.337-.187 3.56-3.725 3.56-3.725l2.586-.477.528-.833c-1.797-2.114-3.713.698-3.713.698l-3.12 3.278z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.97 148.545c-.122-.982 1.22-3.863 1.456-3.98 1.547.46 2.894 1.152 3.462-2.07-.897 1.614-3.46.363-3.46.363l-.86.98.12.53-2.61 3.37 1.893.807z",
    fill: "#d20014",
    stroke: "#d20014"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M236.224 161.65c-.19-.045-18.517-10.44-18.517-10.44-1.334 2.25-.128 5.52.457 6.028.034 1.5-.602 2.306.707 5.44.387 2.035 1.33 3.912 2.7 5.026 1.672 6.417 8.223 6.848 10.747 1.624l3.907-7.677z",
    fill: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.352 168.512l-12.548-7.355c-4.036.567.085 8.056.326 8.71l12.116 4.304.106-5.658z",
    fill: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.243 165.846l-28.35-15.09-.484.673 29.904 16.646-1.07-2.23zm-29.715-15.909l-.514-.3-.265-.856-4.2-1.04 2.757 2.935 1.24-.177.515.3.466-.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.232 151.782c.332-.896.773-1.828 1.772-2.907l1.436 1.056-1.425 2.4-1.783-.548z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1 155.18l.593 1.168c.307-.232 3.004-4.578 3.004-4.578l2.492-.82.468-1.014c-2.002-1.85-3.498 1.342-3.498 1.342l-3.06 3.903z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.772 156.836c-.2-1 .484-4.197.7-4.345 1.56.466 2.863.598 3.223-2.62-.907 1.528-3.328.952-3.328.952l-.71 1.085.15.38-2.06 3.95 2.025.6z",
    fill: "#d20014",
    stroke: "#d20014"
  }))), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    transform: "matrix(-1 0 0 1 499.86 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-170.667) scale(1.70667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.757 125.603l-.465 9.07h2.9l-.425-8.992 3.023-.423-.335-3.582-7.51.29.04 3.253 2.772.385z",
    fill: "#016a16",
    stroke: "#016a16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b",
    fill: "#016a16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.817 121.898c-7.764-7.77-13.878-3.98-15.334-2.902.963.187 1.826-.412 2.273-.48-.28.353-.865 1.23-.865 1.23s2.4-1.135 2.67-1.03c-.347.275-.728.935-.728.935.178.07 1.528-1.056 1.795-1.076-.41.466-.54 1.528-.54 1.528l1.17-.545c.305.216-.084.63.18.61 1.945-.16 4.678 1.776 5.054 2.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.895 123.32c-.81-1.853-15.588-5.004-18.56.245 1.164.293 2.276-.976 2.276-.976l-.1 1.17 1.972-1.512-.708 1.56 1.568-1.268-.05 1.27 1.92-2.1-.252 1.22 1.72-.73-.203 1.023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.238 123.614c-3.793-2.537-9.66-.83-9.66-.83-3.74 2.1-5.736 1.72-6.22 5.61.355-.145 1.366-1.365 1.366-1.365l.76 1.512.25-2.147.608 1.66.91-2.733.203 1.854 1.416-1.854.658.536.607-1.415.556.927s.962-.585 1.52-.244l1.06-1.22.253.88.91-1.074.355.78.91-.83-.05.586 3.135.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.38 124.053c-2.643-.05-10.226 2.812-12.188 5.806a13.29 13.29 0 0 1 1.263-.636l.387 1.203.473-1.203.1.927c.29-.723.618-.805 1.164-.048l.2-1.122.305 1.073.505-1.17s.318 1.27.506 1.22c0 0 .838-2.195 1.214-2.294l.1 1.365.506-1.366.456 1.024.1-1.464.506 1.122s.266-1.103.658-1.317l.758.683 3.378-2.427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.888 124.678c-3.52 1.35-6.67 6.18-6.43 8.226 1.565-1.94 1.23-1.674 1.928.56 0 0 .264-1.955.53-2.187l.46 1.446.17-1.892.47.023-.12-1.187.698.535c-.163-.677-.338-.906.386-1.488 0 0-.917.117-.193-1.535l.675.65s-.12-.72.12-1l2.485-.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.23 125.04l-1.33 2.534.68.197-1.534 1.153 1.296-.132s-1.978.725-2.217 2.666l2.013-.888s-1.706 1.744-1.945 2.797l1.16-1.02s-1.125 1.217-.955 3.06l.853-.954c-.204 2.238-.136 2.436.888 4.147 0 0-.273-2.633.034-2.962l2.25 2.337-1.26-3.324s1.397 2.106 2.25 1.91l-1.774-2.7 1.74 1.415-1.978-2.96 1.84.558s-1.33-1.677-1.227-2.73l1.262 1.382s-.477-1.58-.34-2.04l.647.132-1.262-1.448.853-.165-.102-.953.615-.197-.034-1.053m-1.093-.005c-2.184 2.96-1.058 7.535-2.354 9.87"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(-1 0 0 1 499.86 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.945 166.535s1.19-9.945 1.186-14.225c0-3.37-.813-10.835-.813-10.835H247.9s-.52 7.43-.442 10.79c.1 4.28 1.186 14.27 1.186 14.27h2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.674 141.953h3.96l-.465-2.666h-2.87l-.626 2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.927 139.816h3.54l-.668-2.666h-2.18l-.693 2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.155 137.655h2.95l-.5-2.666h-1.876l-.575 2.665z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71 134.673h-2.064l-.21.964h2.442l-.17-.964zm.422 29.694h-2.62m2.763-1.947h-2.94m3.329-1.976h-3.727m3.919-2.154h-3.9m3.927-2.15h-4.102m4.262-1.97h-4.45m4.46-1.79h-4.65m4.622-2.16h-4.65m4.495-2.136h-4.495m4.289-2.17H247.6m3.867-1.959h-3.672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 119.044c-.69-.324-2.246-1.313-1.784-1.903l.713-1.213c1.01-2.277-.02-1.395-.127-2.106-.103-.68 3.865-.148 3.924 1.398.016.426-.295.176-.252 2.61l-.755 1.46c-.565.052-1.234-.015-1.72-.244z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.392 124.934l-.986-.83.273-7.105.964.282-.252 7.652z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.672 119.246c.62-.362 1.024-1.443.65-2.085-1.016-1.286-1.673-.755-3.378-1.335-.34.362-1.055 1.06-.902 1.58 2.242 1.055 1.372.155 2.114.287.4.07.658.545 1.516 1.554z",
    fill: "#d20014",
    stroke: "#d20014"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-170.667) scale(1.70667)"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#c",
    transform: "matrix(1 0 0 -1 -.002 320.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.358 161.75c0 1.3-.815 2.353-1.818 2.353-1.004 0-1.82-1.054-1.82-2.353v-1.276h3.638v1.276z",
    fill: "#016a16",
    stroke: "#fff",
    strokeWidth: 0.181,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.539,
    cy: 160.063,
    rx: 1.806,
    ry: 0.898,
    fill: "#fff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.126 161.075l-.31-3.297h1.382l-.226 3.297h-.846z",
    fill: "#016a16",
    stroke: "#f1b517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M238.538 160.118c-.265.493-1.06.852-2 .852-.937 0-1.727-.36-1.992-.852a.756.756 0 0 0-.1.36c0 .668.938 1.21 2.093 1.21 1.154 0 2.09-.542 2.09-1.21a.748.748 0 0 0-.092-.36z",
    fill: "#016a16",
    stroke: "#fff",
    strokeWidth: 0.237,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.035 172.786l-7.06-2.19-3.076-5.254-10.894-.535.378 3.94 9.28 1.777.882 1.58 10.666 2.97-.177-2.288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.662 174.254l-11.149-16.398-.547.41 11.06 16.468.636-.48z",
    fill: "#503200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55 158.5l-1.19-1.992c-.222-.368-.56-.49-1.058-.228-.484.255-.437.76-.24 1.123l1.1 1.852 1.39-.755z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.986 164.127l-22.496-2.286-.547 3.272 22.387 2.25.656-3.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.09 160.997l-.584 4.538h.948l.656-4.15-1.02-.388zm3.754.738l-.255 4.08.582.07.474-3.622-.802-.528zm15.241 1.759l-.547 3.834 1.094-.035.437-3.8h-.985zm3.351.106l-.78 4.433 1.24.18.353-2.332c.1.47.53.825 1.045.825.59 0 1.07-.464 1.07-1.032 0-.568-.48-1.026-1.07-1.026-.41 0-.78.24-.94.687l.23-1.662-1.15-.073zm-8.119.72l-3.094 3.48.36.424 3.972-2.71-1.238-1.195zm-7.193 8.68l3.094-3.482-.36-.423-3.972 2.71 1.238 1.195zm8.096-.87l-3.764-2.91-.387.272 2.964 3.756 1.186-1.12zm-9.282-6.717l3.816 2.81.464-.348-2.99-3.755-1.29 1.293zm4.152-2.319l.365 4.573.513-.022 1.207-4.452-2.085-.1zm1.25 11.096l-.364-4.574-.565-.053-.69 4.626h1.62zm5.06-6.164l-4.794.51-.073.457 4.85.634.018-1.6zm-11.407 1.584l4.68-.74.1-.365-4.842-.54.063 1.644z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 227.693,
    cy: 168.548,
    rx: 1.27,
    ry: 1.225
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.438 168.548c0 3.592-3.022 6.507-6.745 6.507-3.723 0-6.745-2.915-6.745-6.507 0-3.592 3.022-6.507 6.745-6.507 3.723 0 6.745 2.916 6.745 6.508zm-1.347 0c0 2.874-2.418 5.207-5.397 5.207-2.98 0-5.398-2.333-5.398-5.207 0-2.874 2.42-5.207 5.398-5.207 2.98 0 5.398 2.334 5.398 5.208z",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.48 165.264l-1.057-.796m8.611.025l.902-.92m1.031 9.127l-1.11-.87m-8.377 1.866l.954-1.02m21.762-10.554l1.155 5.886-.94.497-1.015-6.3.8-.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.592 161.364c-.535-.224-1.232.155-2.374-1.292-1.878 1.723-.107 1.98.18 3.686.53.218.857-1.323 2.3-1.48.18-.02 2.3-.204 2.3-.204l-.533-.726s-1.474.04-1.873.016z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36 162.518l-.215-1.756c-.232-.62-1-.087-1 .275l.197 1.62 1.017-.14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.765 167.372l.02 1.637c-.537.182-.455.584-.438 1.167l.02 4.772c-.19.315-.78.33-1.055.578-.277.248-.242.73 1.02 1.047l.975.035c1.486-.325 1.793-.818 1.048-1.095-.397-.148-.92-.324-1.117-.557l.033-1.137.965.036c.26 0 .753-.652.77-1.185l.005-2.47c-.035-1.4-1.085-1.558-1.38-1.54l.02-1.29-.885.002zm1.63 2.73c.018-.4-.555-.757-.786-.767-.23-.01-.735.467-.752.867v1c.034.367.327 1.61.915 1.7.28.044.64-.4.64-.766l-.017-2.034z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.275 172.328c-.636-.257-.63 1.172-.63 1.172l1.002.01c.44.2.792.843.512 1.16-.232.26-2.178-.442-2.31-.038.345 1.94 2.918 2.688 3.85 1.84.91-.832 1.14-3.05-1.818-3.63l-.607-.514zm.595.528l-.292.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.943 173.055l-.963-4.05m2.132 3.817l-1.48-3.153m4.026 2.324l-3.337-1.792m4.782 1.427l-6.192-2.688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.215 166.013s-2.254-.036-2.656.122c-.163.064.566.825.415 1.115-.563 1.083-4.394.934-4.697.698-.52-.405 3.568-.753 3.595-1.03.03-.315-.605-1.145-.506-1.654.128-.66 1.788-.907 1.788-.907l2.06 1.656z",
    fill: "#d20014",
    stroke: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.233 168.05l-5.102-4.222s-.224-.238-.412-.033c-.184.2.07.43.07.43l5.262 4.35.183-.525z",
    fill: "#503200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.146 172.217c-.09-.087-4.155-3.608-4.155-3.608l-.27-1.03s-.628.426-.858.646c-.23.22-.587.82-.587.82l1.138.05 3.595 3.295 1.138-.173z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.534,
    cy: 177.056,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.641,
    cy: 175.716,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.091,
    cy: 176.593,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.153,
    cy: 177.445,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.487,
    cy: 177.64,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.846,
    cy: 177.64,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.18,
    cy: 177.591,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.988,
    cy: 176.325,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.604,
    cy: 176.398,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.144,
    cy: 176.203,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.361,
    cy: 174.961,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.846,
    cy: 174.937,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.47 177.99c0-.315-.77-.18-.77-.55 0-.41 1.174-.11 1.336.253.66-.596.944-.16 1.348.02.575-.855 1.287-.823 1.98-.197.402-.443 1.41-.297 1.758.197.664-.66 1.255-.497 1.715-.02.186-.346.458-.27.654-.02.355-.628 1.243-.44 1.617-.024.332-.367.673-.08 1.114.19.298-.28.78-.228.78.05 0 .288-.63.187-.63.473 0 .256.46.127.46.45 0 .255-.68.35-.786-.056-.23.44-1.062.27-1.144-.138-.276.334-.897.435-1.246-.06-.286.234-.63.267-.787.03-.517.557-1.388.443-1.688-.17l-.295.013c-.508.69-1.302.37-1.52-.01-.853.615-1.362.42-1.838.02-.548.666-1.38.62-1.573 0-.368.267-1.137.33-1.137.017 0-.3.653-.192.653-.47zm1.655.15c0 .144-.195.26-.436.26-.24 0-.436-.116-.436-.26 0-.142.195-.26.435-.26s.435.118.435.26zm1.82-.217c0 .172-.235.312-.524.312-.288 0-.523-.14-.523-.312 0-.173.235-.312.524-.312.29 0 .525.14.525.313zm3.575.197c0 .175-.212.316-.474.316s-.474-.14-.474-.316c0-.174.212-.316.474-.316s.474.142.474.316zm-1.904-.083c0 .22-.207.4-.463.4s-.464-.18-.464-.4c0-.22.207-.4.463-.4s.463.18.463.4zm4.06.01c0 .198-.186.358-.414.358-.23 0-.415-.16-.415-.358 0-.197.186-.357.415-.357.228 0 .414.16.414.357zm-1.244.083c0 .128-.12.23-.267.23-.148 0-.268-.102-.268-.23 0-.127.12-.23.268-.23.147 0 .267.103.267.23zm2.422.094c0 .183-.135.33-.302.33-.166 0-.3-.147-.3-.33 0-.183.134-.332.3-.332.167 0 .302.15.302.332z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "matrix(-1 0 0 1 499.86 0)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.231
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.837 165.718c-2.512 0-4.55.944-4.55 2.102 0 .2.057.39.17.572.542.63 2.306 1.087 4.397 1.087 1.957 0 3.625-.403 4.277-.97.165-.217.257-.447.257-.69 0-1.158-2.038-2.102-4.55-2.102z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.427 167.98v7.06c0 .827-2.048 1.498-4.572 1.498s-4.573-.67-4.573-1.5v-7.057c0 .83 2.05 1.5 4.573 1.5 2.524 0 4.572-.67 4.572-1.5z",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.282 167.982v1.082l2.22 6.845 1.772-5.265 1.946 5.465 1.425-5.16 1.783 3.47v-1.92l-1.656-3.363a8.25 8.25 0 0 1-.593.134l-1.03 3.813-1.446-3.604a14.522 14.522 0 0 1-.715-.024l-1.454 3.627-1.66-4.367c-.377-.217-.594-.466-.594-.734z",
    fill: "#d20014",
    stroke: "#d20014",
    strokeWidth: 0.183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.427 173.72v1.32c0 .826-2.048 1.498-4.572 1.498s-4.573-.672-4.573-1.5v-1.317c0 .83 2.05 1.5 4.573 1.5 2.524 0 4.572-.67 4.572-1.5z",
    fill: "#0a328c",
    stroke: "#0a328c",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.737 175.085c-.372.055-.77.097-1.185.118l.01 1.317c.418-.02.815-.062 1.187-.118l-.013-1.317zm-4.869-.23l-.012 1.312c.353.1.75.185 1.186.246v-1.317a8.907 8.907 0 0 1-1.174-.24zm-1.586-1.132v1.317c0 .246.185.474.506.68l.023-1.302c-.335-.21-.528-.443-.528-.695zm9.146.14l-.023.006c-.08.266-.38.515-.83.722l.005 1.312c.53-.245.848-.54.848-.863v-1.177z",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.427 168.027v7.012c0 .827-2.048 1.498-4.572 1.498s-4.573-.67-4.573-1.5v-7.01",
    fill: "none",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.392 167.52c0 .5-1.584.907-3.537.907-1.954 0-3.538-.406-3.538-.907 0-.5 1.584-.907 3.538-.907 1.953 0 3.537.406 3.537.907z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.698 168.19l.157 1.25c.307.022.626.038.953.04l.232-1.29h-1.342zm4.102-.303l-.91.247.057 1.177c.31-.052.602-.116.866-.19l-.012-1.233zm-5.403-1.907c-.26.075-.5.164-.72.262l.127.945.58-.185.013-1.023zm2.44-.374c-.122 0-.24.007-.36.01l.197 1.184.605-.012.237-1.154a9.727 9.727 0 0 0-.68-.028zm2.673.418l-.122 1.034.69.244.077-1.015a5.26 5.26 0 0 0-.645-.263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.993 168.8l.184-1.288-.935-.506.028 1.465.723.33zm8.403-.278l.042-1.288-.876.262.834 1.026z",
    strokeWidth: 0.183
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.686 160.03c.83-.116 2.062 1.023 2.136 2.432.06 1.118-1.69 1.06-1.69 1.06-.09.458-1.055.88-1.84.916-.763.033.207-1.432.207-1.432-.476-1.26.147-2.748.147-2.748l1.04-.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5 162.948l.8-.03s.06.415.208.43c.157.018.326-.4.326-.4l1.217-.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.13 160.86c.68-.492.085-1.48-.385-1.49l-1.098.03c-.517.01-1.392.572-1.276 1.058.103.424.388.618.832.544.202-.033.626-.563.83-.572.276-.013.88.588 1.1.43z",
    fill: "#d20014",
    stroke: "#f1b517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.242 174.855c-.617.078-.73.788-.5 1.44-2.686.756-5.086 1.74-7.455 2.406-.095-.473 1.174-1.844 1.174-1.844.337.162.588.93.588.93.084-1.578 1.64-2.628 1.64-2.628-.925-.122-3.733.967-4.07 1.412 0 0 1.088-.12 1.256 0 0 0-2.14 2.312-2.237 3 .333.75 4.027 1.31 4.027 1.31-.058.196-1.087.932-1.087.932 1.47.322 3.685-.718 4.347-1.35 0 0-1.728-.144-3.074-1.235 0 0 .277.68.11 1.004 0 0-2.1-.604-2.318-.952.006-.03 4.966-1.315 7.368-2 .088.428.565 1.238 1.138 1.047.374-.125.256-.866.117-1.39a.77.77 0 0 0 .505.185c.422 0 .767-.327.767-.735 0-.407-.345-.74-.767-.74a.755.755 0 0 0-.72.505c-.096-.453-.345-1.354-.808-1.295zm1.89 1.528c0 .19-.162.345-.36.345a.352.352 0 0 1-.357-.345c0-.19.16-.345.358-.345.197 0 .358.154.358.345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.068 177.884c.183-.367-.162-2.212-.162-2.212-.373.042-.882.68-.882.68.48-1.51-.865-4.036-.865-4.036.91.19 3.944 3.128 4.102 3.657 0 0-1.33-.474-1.53-.415.217 1.506 1.258 2.205 1.65 2.988 0 0-1.726.38-1.553 1.822l-1.128.02c-.39-.48.152-1.275.152-1.275l-7.74-3.24c-.498-.21-1.62-.72-1.45-1.32.168-.603 2.015.252 2.47.4l6.934 2.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.635 176.54l.91-1.672c.326-.44-.346-.92-.823-.356l-1.02 1.527c-.454.836.5 1.066.933.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0.312
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.2 307.825l-.108-3.114-3.766.208-.215 3.392 4.09-.485z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.672 312.19l-5.037-2.824c20.768 1.903 25.01-5.34 30.028-5.728 3.085-.24 3.567 3.417-2.41 1.677l1.545 3.825s-14.743 8.294-29.234 4.868l5.108-1.817zm90.474-4.365l.107-3.114 4.607.107.215 3.39-4.93-.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.63 311.428l4.74-2.586c-23.79.71-18.374-3.907-30.276-5.202-3.076-.333-5.388 3.62 2.41 1.677l-1.545 3.825 3.74.003c8.104 5.336 19.04 5.813 26.285 4.1l-5.355-1.817z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.167 305.337v5.383s13.19 4.894 36.726 4.894c23.637 0 36.725-4.894 36.725-4.894v-5.383s-9.982 4.6-36.725 4.6c-26.642 0-36.726-4.6-36.726-4.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.138 310.75l1.164-3.94.54.148-1.026 3.476 2.012.553-.137.465-2.552-.7zm3.817-1.733l.065-.774.174-.664.576.14-.174.663-.33.71-.31-.076zm5.675-.266l.55.11-.49 2.32c-.084.403-.2.714-.343.933-.145.22-.357.38-.635.48-.28.1-.618.11-1.02.03-.39-.075-.695-.203-.915-.38a1.143 1.143 0 0 1-.413-.668c-.054-.267-.036-.613.054-1.038l.49-2.32.55.108-.49 2.317c-.072.35-.093.613-.06.79.032.18.12.33.265.45.145.123.336.207.572.253.405.08.713.048.922-.095.21-.144.368-.467.474-.97l.49-2.32zm.62 4.285l.686-4.044.57.09 1.662 3.523.54-3.175.53.084-.685 4.044-.57-.09-1.662-3.525-.538 3.18-.532-.085zm4.337.655l.583-4.06.557.075-.583 4.06-.557-.075zm1.6-1.79c.08-.676.33-1.185.752-1.525.42-.34.93-.48 1.524-.413.39.043.73.17 1.02.385.293.214.502.49.628.83.126.34.165.713.117 1.12a2.36 2.36 0 0 1-.392 1.08c-.21.307-.485.527-.82.66-.338.132-.69.178-1.056.138a2.05 2.05 0 0 1-1.032-.396c-.29-.22-.498-.5-.622-.837a2.237 2.237 0 0 1-.12-1.043zm.575.07c-.058.492.032.894.273 1.206.24.313.566.492.98.537.42.047.782-.058 1.087-.313.305-.255.49-.645.55-1.17a2.03 2.03 0 0 0-.07-.886 1.3 1.3 0 0 0-.442-.63 1.418 1.418 0 0 0-.728-.288c-.396-.044-.75.05-1.067.28-.316.23-.51.653-.583 1.265zm3.94 2.418l.346-4.084.574.045 1.952 3.382.272-3.207.537.042-.346 4.085-.575-.046-1.95-3.385-.273 3.21-.54-.042zm5.954.415l.186-4.095 2.863.12-.022.484-2.3-.097-.06 1.268 1.993.084-.022.483-1.992-.084-.084 1.86-.56-.024zm3.13.133l1.713-4.067.604.01 1.656 4.13-.64-.01-.47-1.25-1.776-.034-.492 1.232-.596-.012zm1.26-1.66l1.44.027-.422-1.143a10.906 10.906 0 0 1-.284-.855c-.06.262-.14.52-.245.778l-.49 1.193zm3.265 1.725l.01-4.097h.562l-.01 4.1-.56-.002zm2.633-.01l-.054-3.615-1.4.02-.007-.484 3.367-.045.006.483-1.405.02.055 3.614-.562.008zm4.168-.1l-.198-4.093.562-.025.175 3.61 2.088-.094.024.483-2.65.12zm2.86-.124l1.324-4.2.604-.04 2.036 3.968-.638.044-.586-1.204-1.772.122-.374 1.27-.595.04zm1.097-1.762l1.437-.1-.526-1.1a11 11 0 0 1-.363-.828 5.246 5.246 0 0 1-.17.797l-.378 1.23zm4.987 1.294l-.466-4.074 2.848-.303.055.482-2.288.244.144 1.26 1.98-.21.056.48-1.98.212.21 1.85-.558.06zm3.115-2.34c-.1-.672.01-1.225.327-1.658.318-.432.774-.69 1.367-.77a2.09 2.09 0 0 1 1.09.123c.338.136.612.353.823.65.21.298.346.65.406 1.055.06.412.03.792-.095 1.14a1.72 1.72 0 0 1-.622.838c-.29.21-.62.34-.984.39a2.056 2.056 0 0 1-1.102-.13 1.85 1.85 0 0 1-.82-.657 2.265 2.265 0 0 1-.39-.98zm.574-.07c.072.49.265.856.58 1.1.313.243.676.337 1.087.28.42-.057.744-.247.972-.568.23-.322.304-.743.227-1.265a2.05 2.05 0 0 0-.302-.84 1.333 1.333 0 0 0-.593-.504 1.437 1.437 0 0 0-.78-.1 1.45 1.45 0 0 0-.96.532c-.244.3-.322.756-.23 1.366zm4.46 1.376l-.758-4.032 1.853-.325c.372-.065.662-.078.87-.04.207.04.385.14.536.303.15.163.246.355.288.577a1 1 0 0 1-.152.774c-.155.23-.428.407-.82.53.16.043.284.09.373.143.188.115.375.267.56.456l.933.97-.696.12-.71-.74a7.93 7.93 0 0 0-.504-.487 1.31 1.31 0 0 0-.332-.22.872.872 0 0 0-.272-.063c-.066-.002-.17.01-.312.034l-.64.113.336 1.79-.554.097zm.13-2.35l1.19-.208c.25-.044.444-.104.577-.18a.627.627 0 0 0 .324-.68.61.61 0 0 0-.304-.432c-.166-.098-.405-.12-.714-.065l-1.323.23.25 1.335zm6.71-.446l.578.015c-.013.46-.143.836-.388 1.13-.246.292-.584.486-1.016.58-.446.096-.83.088-1.15-.027a1.738 1.738 0 0 1-.817-.624 2.74 2.74 0 0 1-.47-1.024c-.096-.416-.098-.797-.005-1.143.092-.346.272-.632.54-.86.265-.226.582-.38.947-.46.415-.09.787-.063 1.117.08.33.142.593.385.79.73l-.51.24c-.165-.27-.353-.45-.567-.544a1.19 1.19 0 0 0-.736-.05c-.32.07-.568.202-.747.396-.18.193-.284.424-.313.69-.03.268-.012.533.05.797.08.34.2.625.36.857.163.23.367.386.613.464.246.078.495.09.748.035.307-.067.547-.21.72-.426.173-.217.258-.502.255-.855zm1.56 1.114l-1.142-3.947 2.958-.797.135.466-2.417.65.35 1.21 2.263-.61.135.463-2.263.61.39 1.344 2.51-.676.135.466-3.053.822z",
    fill: "#000",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/ht.5fd55b7bfd3b949fa4b49e7dd7e3d9ed.svg";
export { ForwardRef as ReactComponent };